export default __webpack_public_path__ + "img/timeline.7933e57b.svg";